import { RuleDefinition } from "../type-validator";
import { custom } from "./custom";

export const nonNegativeInteger: RuleDefinition = custom((value) => [
  typeof value === "number" && Number.isInteger(value) && value >= 0,
  "a non-negative integer",
]);
